/** Capital against your limits: Reported and Marked CET1 each beside their own limit and room, the closest flagged, and the Marked limit in Reported terms (`capitalLimits.ts`). The layout is fixed; only the flag moves. */
import { GxTerm } from "../theme/GxTerm";
import { BASIS_HEADING, type CapitalLimits } from "./capitalLimits";
import "./capital-limits.css";

export function CapitalLimitsBlock({ block, testId = "capital.limits" }: { readonly block: CapitalLimits; readonly testId?: string }) {
  return (
    <section className="gx-caplim" data-testid={testId} aria-label="Capital against your limits">
      <table className="gx-caplim-t">
        <caption className="gx-caplim-h gx-eyebrow">Capital against your limits ({BASIS_HEADING[block.basis]})</caption>
        <thead className="gx-sr"><tr><th scope="col">Measure</th><th scope="col">Reading</th><th scope="col">Limit</th><th scope="col">Room</th><th scope="col">Which is closest</th></tr></thead>
        <tbody>
          {block.rows.map((r) => (
            <tr key={r.kpi} data-testid={`${testId}.${r.kpi}`} {...(r.closest ? { "data-closest": "true" } : {})}>
              <th scope="row" className="gx-caplim-nm"><GxTerm term={r.kpi}>{r.name}</GxTerm></th>
              <td className="gx-num gx-caplim-v">{r.value}</td>
              <td className="gx-num gx-caplim-l">{r.own ? "your limit" : "usual limit"} {r.limit}</td>
              <td className={`gx-num gx-caplim-r${r.roomPoints < 0 ? " gx-caplim-r--past" : ""}`}>{r.room}</td>
              <td className="gx-caplim-f">{r.closest ? <span className="gx-caplim-flag" data-testid={`${testId}.closest`}>Closest</span> : null}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {block.translation === null ? null : <p className="gx-small gx-muted gx-caplim-tr" data-testid={`${testId}.translation`}>{block.translation}</p>}
    </section>
  );
}
